import { render, staticRenderFns } from "./RepeaterHotelissimaTable.vue?vue&type=template&id=af938bc0&scoped=true"
import script from "./RepeaterHotelissimaTable.vue?vue&type=script&lang=js"
export * from "./RepeaterHotelissimaTable.vue?vue&type=script&lang=js"
import style0 from "./RepeaterHotelissimaTable.vue?vue&type=style&index=0&id=af938bc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af938bc0",
  null
  
)

export default component.exports